import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { event } from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../_services/app.service';
import { WaypointsMapComponent } from '../../map/WaypointsMap/Waypoints.component';
import { Subject, Subscription } from 'rxjs';
import { interval } from 'rxjs/observable/interval';
import { takeUntil } from 'rxjs/operators';
declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-bidding',
  templateUrl: './bidding.component.html',
  styleUrls: ['./bidding.component.scss']
})
export class BiddingComponent implements OnInit, OnDestroy {

  BiddingData: any = {};
  static that: BiddingComponent;
  Shipper: any = {};
  Consignee: any = {};
  RequiredVehicle: any = [];
  ProductList: any = [];
  ProductTotal: any = {};
  TransporterList: any;
  TransporterListHired: any[] = [];
  IndentNo: string = '';
  SelectedTransporterList: any[] = [];
  IndentId: string = '';
  isCloseBid: boolean = false;
  SelectedBidList: any;
  SelectedTransporterId: any;
  isSortByAmount: boolean = false;
  isDisabled: boolean = false;
  IsTripwiseBid: boolean = false;
  BookingId: any;
  //added by vithu 10-09-2025 - Siddarth
  private destroy$ = new Subject<void>();
  private intervalSubscription: Subscription | null = null;

  constructor(
    private _appService: appService,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    this.GetTransporterListHired();
  }

  startInterval() {
    if (this.intervalSubscription) return; // prevent multiple intervals

    this.intervalSubscription = interval(3000).subscribe(() => {
      if (!this.isBidOpen) return;

      if (this.IndentId && !this.IsTripwiseBid) {
        this.GetSelectedTranspoterBidList();
      }
      if (this.BookingId && this.IsTripwiseBid) {
        this.GetSelectedTranspoterBidListForTrip();
      }
    });
  }

  stopInterval() {
    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
      this.intervalSubscription = null;
    }
  }

  ngOnDestroy() {
    this.stopInterval();
  }

  GetTransporterListHired() {
    this._appService
      .Get("OrdersByVehicle", "GetTranspoterListHired")
      .subscribe(
        (response) => {

          this.TransporterList = response;
          this.pushTranporterData();
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "error"
          );
        }
      );
  }

  pushTranporterData() {
    for (let i = 0; i < this.TransporterList.length; i++) {
      this.TransporterListHired.push({
        Id: this.TransporterList[i].Id,
        Name: this.TransporterList[i].Name,
        Email: this.TransporterList[i].Email,
        Phone: this.TransporterList[i].Phone,
        Rating: this.TransporterList[i].Rating,
        isSelected: false,
        isDisabled: false
      });
    }
  }


  InitData() {
    this.Shipper = this.BiddingData.Shipper;
    this.Consignee = this.BiddingData.Consignee;
    this.RequiredVehicle = this.BiddingData.RequiredVehicle;
    this.ProductList = this.BiddingData.ProductList;
    this.ProductTotal = this.BiddingData.ProductTotal;
    this.startInterval();
  }

  allTransporters(event) {
    const checked = event.target.checked;
    this.TransporterListHired.forEach(item => item.isSelected = checked);
  }

  checkUncheck(event) {
    var id = event.target.name;
    if (this.TransporterListHired[id]['isSelected'] == true) {
      this.TransporterListHired[id]['isSelected'] = false;
    } else {
      this.TransporterListHired[id]['isSelected'] = true;
    }
  }

  SelectedTransporters() {
    this.SelectedTransporterList = [];

    for (let i = 0; i < this.TransporterListHired.length; i++) {
      if (this.TransporterListHired[i]['isSelected'] == true) {

        this.SelectedTransporterList.push({
          TransporterId: this.TransporterListHired[i]['Id'],
          IndentId: this.IndentId,
          Email: this.TransporterListHired[i]['Email'],
          Phone: this.TransporterListHired[i]['Phone'],
          Transporter: this.TransporterListHired[i]['Name'],
          IndentNo: this.IndentNo
        });
      }

    }
  }

  GetSelectedTranspoterBidList() {
    this.SelectedBidList = [];
    this._appService
      .GetByTwoId("OrdersByVehicle", "GetSelectedTranspoterBidList", this.IndentId, this.isSortByAmount)
      .subscribe(
        (response) => {

          this.SelectedBidList = response;
          this.CombineAlreadyCheckedTransporter();
          this.stopInterval();
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "error"
          );
        }
      );
  }

  BidTransporterId: any;
  CombineAlreadyCheckedTransporter() {
    for (let i = 0; i < this.SelectedBidList.length; i++) {
      if (!this.IsTripwiseBid) {
        var toSelect = this.TransporterListHired.find(c => c.Id == this.SelectedBidList[i].Id);
        if (toSelect) {
          toSelect.isSelected = true;
          toSelect.isDisabled = true;
        }
      } else {
        if (this.BidTransporterId) {
          var toSelect = this.TransporterListHired.find(c => c.Id == this.BidTransporterId);
          if (toSelect) {
            toSelect.isSelected = true;
            toSelect.isDisabled = true;
            this.SelectedTransporterId = this.BidTransporterId
          }
        }
      }
    }
  }

  SelectBidTransporter() {
    this.SelectedTransporterId = $("input[name='transporter']:checked").val();
  }

  CheckSelectedTransporter() {
    $('input:radio[name="transporter"]').attr("disabled", "true");
    this.isDisabled = true;
  }

  checkUncheckSort(event) {
    this.isSortByAmount = event.target.checked;
    this.GetSelectedTranspoterBidList();
  }

  // added by vithu 20-08-2025 - Siddarth
  InitBookingData() {
    this.TripDataForBidding();
    this.GetAddressSequenceById();
    this.startInterval();
  }

  AddressList: any = [];
  GetAddressSequenceById() {
    this.AddressList = [];
    this._appService
      .GetById("Booking", "GetAddressSequenceById", this.BookingId)
      .subscribe(
        (response) => {
          this.AddressList = response;
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "error"
          );
        }
      );
  }

  checkUncheckSortForTrip(event) {
    this.isSortByAmount = event.target.checked;
    this.GetSelectedTranspoterBidListForTrip();
  }

  onTransporterChange(Id: any) {
    this.stopInterval();
  }

  BookingData: any = {};
  isBidOpen: boolean = true;
  TripDataForBidding() {
    this._appService
      .GetByTwoId("OrdersByVehicle", "TripDataForBidding", this.BookingId, null)
      .subscribe(
        (response) => {
          this.BookingData = {};
          this.BookingData = response.Table[0];
          this.BookingData.ProductList = [];
          this.BookingData.ProductList = response.Table1;
          this.BookingData.SumOfQty = 0;
          this.BookingData.SumOfWeight = 0;
          this.BookingData.ProductList.forEach(element => {
            this.BookingData.SumOfQty += parseFloat(element.Qty);
            this.BookingData.SumOfWeight += parseFloat(element.Weight);
          });

          if (this.BookingData.BidOpen == false || this.BookingData.BidOpen == null) {
            this.isBidOpen = true;
          } else {
            this.isBidOpen = false;
          }
          this.BookingData.Orders = [];
          this.BookingData.Orders = response.Table3;
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching data !",
            "error"
          );
        }
      );
  }

  //added by vithu 21-08-2025 - Siddarth
  SelectedTransportersForTrip() {
    this.SelectedTransporterList = [];

    for (let i = 0; i < this.TransporterListHired.length; i++) {
      if (this.TransporterListHired[i]['isSelected'] == true && this.TransporterListHired[i]['isDisabled'] == false) {

        this.SelectedTransporterList.push({
          TransporterId: this.TransporterListHired[i]['Id'],
          BookingId: this.BookingId,
          Email: this.TransporterListHired[i]['Email'],
          Phone: this.TransporterListHired[i]['Phone'],
          Transporter: this.TransporterListHired[i]['Name'],
          BookingNo: this.BookingData.TripNo
        });
      }

    }
  }

  GetSelectedTranspoterBidListForTrip() {
    this.SelectedBidList = [];
    this._appService
      .GetByTwoId("OrdersByVehicle", "GetSelectedTranspoterBidListForTrip", this.BookingId, this.isSortByAmount)
      .subscribe(
        (response) => {

          this.SelectedBidList = response;
          this.CombineAlreadyCheckedTransporter();
          this.stopInterval();
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "error"
          );
        }
      );
  }

  openDropPointModal() {
    $('#ModalRouteOptBid').modal('show');
    // this.GetOrderRouteAndLoadPlan(this.BookingId);
    // $("#DropPointsModal").modal('show');
  }

  closeDropPointsModal() {
    this.stopInterval();
    $('#ModalRouteOptBid').modal('hide');
  }

  @ViewChild(WaypointsMapComponent) ChildWaypointsMapComponent: WaypointsMapComponent;
  GetOrderRouteAndLoadPlan(BookingID) {
    this._appService
      .GetById("Booking", "GetOrderRouteAndPlan", BookingID)
      .subscribe(
        (response) => {
          var WayPointsres: any = [];
          var res: any = [];
          var PickUpPoints: any = [];
          WayPointsres.push(
            ...response.map((o) => {
              return {
                location: o.DeliveryAddress,
                stopover: true,
                Order: 0,
                RouteOrder: "A",
                OrderNo: o.OrderNo,
                PickUpContactPersonDetail: o.PickUpContactPersonDetail,
                DeliveryContactPersonDetail: o.DeliveryContactPersonDetail,
                OrderAddress: o.DeliveryAddress,
                weight: o.weight,
                Qty: o.Qty,
                cbm: o.cbm,
              };
            })
          );
          var objPickupLocation: any = {};
          (objPickupLocation.origin = response[0].PickupAddress),
            (objPickupLocation.destination =
              response[response.length - 1].DeliveryAddress),
            (objPickupLocation.TripNo = response[0].TripNo),
            (objPickupLocation.DispatchDate = response[0].DispatchDate),
            (objPickupLocation.Transporter = response[0].Transporter),
            (objPickupLocation.TransporterPhone = response[0].TransporterPhone),
            (objPickupLocation.Driver = response[0].Driver),
            (objPickupLocation.DriverPhone = response[0].DriverPhone),
            (objPickupLocation.Vehicle = response[0].Vehicle),
            (objPickupLocation.VehicleType = response[0].VehicleType);
          PickUpPoints.push(objPickupLocation);

          this.ChildWaypointsMapComponent.OrderInfoLatLong = [
            {
              origin: response[0].PickupAddressLatLong,
              destination: response[0].DeliveryAddressLatLong,
            },
          ];
          //add by maaria on 19-10-2023
          this.ChildWaypointsMapComponent.isAssign = false;
          //end
          this.ChildWaypointsMapComponent.OrderInfo = PickUpPoints;
          this.ChildWaypointsMapComponent.OrderDestinationLocation =
            WayPointsres;
          this.ChildWaypointsMapComponent.initMap();
          $("#ModalRouteOptBid").modal("show");
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        }
      );
  }

}
